import { H7, Stack } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import SpinnerCircular from '~/components/shared/Spinner/SpinnerCircular';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import {
  StandardStepContent,
  StandardStepContentBody,
  StandardStepContentFooter,
} from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';
import { Content } from './ConnectToBank.styled';
import ConnectToBankFooter from './components/ConnectToBankFooter';
import ConnectToBankHeader from './components/ConnectToBankHeader';

const ConnectToBank = () => {
  const {
    klarnaKosma: { transactionFlow },
  } = useSelector((state: RootState) => state);
  const translate = useTranslate();

  return (
    <StandardStepContent>
      <StandardStepContentBody>
        <ConnectToBankHeader />
        <Content>
          {transactionFlow.status === 'inProgress' && (
            <Stack>
              <H7>{translate('Onboarding.ConnectingToKlarna')}</H7>
              <SpinnerCircular color={theme.colors.secondaryGray} />
            </Stack>
          )}
        </Content>
      </StandardStepContentBody>
      <StandardStepContentFooter>
        <ConnectToBankFooter />
      </StandardStepContentFooter>
    </StandardStepContent>
  );
};

export default ConnectToBank;
